import React from 'react'
import parse from 'html-react-parser'
import Fade from 'react-reveal/Fade'

const AgentSalesStats = ({ title, content, stats, team }) => {
  return (
    <section className='agent-sales-stats'>
      <Fade bottom distance='40px'>
        <div className='agent-sales-stats__inner'>
          <div className='agent-sales-stats__content'>
            { team?.title && <h3>{parse(team.title)}</h3> }
            { title && <h4>{parse(title)}</h4> }
            { content && <div className='agent-sales-stats__info'>{parse(content)}</div> }
          </div>
          <div className='agent-sales-stats__stats'>
            <div className='agent-sales-stats__headings'>
              <span>Top Suburbs</span>
              <span>In the last year:</span>
              <span>No. of Sales</span>
              <span>Average</span>
            </div>
            { stats && stats.map((stat, index) => (
              <div className='agent-sales-stats__rows' key={index}>
                <span>{stat.suburbs}</span>
                <span>{stat.lastYear}</span>
                <span>{stat.noSales}</span>
                <span>{stat.average}</span>
              </div>
            )) }
          </div>
        </div>
      </Fade>
    </section>
  )
}

export default AgentSalesStats
